import { applyFilters } from '@wordpress/hooks';
import { useSelect, select, dispatch, withSelect } from '@wordpress/data';
import { _n, __ } from '@wordpress/i18n';
import { TabPanel, PanelRow, ToggleControl, RadioControl, Popover, Button, TextControl, Modal, SelectControl, CheckboxControl, TextareaControl, FormTokenField } from '@wordpress/components';
import { ReactSortable } from 'react-sortablejs';

import { useState, useEffect } from '@wordpress/element';

export default (props) => {
    
    const settings = useSelect((select) => {
        return select('WPTravel/Admin').getAllStore()
    }, []);
    const { updateSettings } = dispatch('WPTravel/Admin');
    const {field_editors} = settings
    
    return <div className="wp-travel-settings-traveller">

        {'undefined' != typeof field_editors &&  'undefined' != typeof field_editors.traveller && field_editors.traveller.length > 0 &&
            <>
                {props.WPTravelFieldEditorPopover('traveller')}
                <div className="components-panel__row wp-travel-action-section">
                    <span><Button isSecondary onClick={() => props.toggleVisible()}>{ _wp_travel.setting_strings.field_editor.add_field }</Button></span>
                    <Button isSecondary onClick={() => props.resetFields('traveller')}>{ _wp_travel.setting_strings.field_editor.reset_field }</Button>
                </div>
                <table>
                    <thead>
                        <tr>
                            <td></td>
                            <td>{_wp_travel.setting_strings.field_editor.field_editor_label}</td>
                            <td>{_wp_travel.setting_strings.field_editor.field_editor_name}</td>
                            <td>{_wp_travel.setting_strings.field_editor.field_editor_type}</td>
                            <td>{_wp_travel.setting_strings.field_editor.field_editor_action}</td>
                        </tr>
                    </thead>
                    <ReactSortable
                        list={field_editors.traveller}
                        setList={sortedList => props.sortFields( sortedList, 'traveller')}
                        handle=".account-detail-sortable"
                        tag="tbody"
                        >
                            {field_editors.traveller.map( ( travellerField, index ) => {
                                
                                return <tr key={index}>
                                    <td>
                                        <span className="account-detail-sortable dashicons dashicons-menu" ></span>
                                    </td>
                                    <td>
                                        {travellerField.label}
                                    </td>
                                    <td>
                                        {travellerField.name}
                                    </td>
                                    <td style={{textTransform: 'capitalize'}}>
                                        {travellerField.type.replace( '_', ' ' )}
                                    </td>
                                    <td>
                                        <Button isSecondary onClick={() => {
                                            props.toggleVisible(travellerField.name, 'traveller')
                                        }}>{ _wp_travel.setting_strings.field_editor.field_editor_edit }</Button>
                                        { ( 'undefined' == typeof travellerField._default || ( 'undefined' != typeof travellerField._default && ! travellerField._default ) ) &&
                                            <Button className="wp-traval-button-danger" isSecondary onClick={ () => {

                                                if ( window.confirm('Are you sure to delete this field?') ) {
                                                    let _traveller_fields = [];
                                                    _traveller_fields = field_editors.traveller.filter((e, newIndex) => {
                                                        return newIndex != index;
                                                    });
                                                    updateSettings({ settings, field_editors:{ ...settings.field_editors, traveller: JSON.parse(JSON.stringify(_traveller_fields)) }  })
                                                }
                                            } }>{ _wp_travel.setting_strings.field_editor.field_editor_delete }</Button>
                                        }
                                    </td>
                                    
                                </tr>
                            } )}
                    </ReactSortable>
                </table>
                <div className="components-panel__row wp-travel-action-section">
                    <span><Button isSecondary onClick={() => props.toggleVisible()}>{ _wp_travel.setting_strings.field_editor.add_field }</Button></span>
                    <Button isSecondary onClick={() => props.resetFields('traveller')}>{ _wp_travel.setting_strings.field_editor.reset_field }</Button>
                </div>
            </>
        }
    </div>
}
